import React from 'react';
interface ToastProps {
  message: string | null;
}
export function Toast({
  message
}: ToastProps) {
  return <div className={`fixed bottom-[100px] left-1/2 -translate-x-1/2 bg-text-dark text-white px-5 py-3 rounded-full text-sm font-semibold z-[300] transition-opacity duration-300 whitespace-nowrap shadow-lg ${message ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-id="element-388">
      {message}
    </div>;
}